<template>
  <v-container fluid class="pa-0">
    <v-timeline dense class="pt-0 mt-3">
      <JobLoggTimelineItem v-for="logg in ParentJobLogg" :key="logg.Id" :item="logg" :statuses="StatusList"
        :substatuses="SubStatusList">
      </JobLoggTimelineItem>
    </v-timeline>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import JobLoggTimelineItem from "@/views/job/viewjob/JobLoggTimelineItem.vue";

export default {
  name: "JobLoggTimeline",
  components: {
    JobLoggTimelineItem,
  },
  mixins: [clientAPI],

  data() {
    return {
      loading: false,
      ParentJobLogg: null,
    };
  },

  mounted() {
    this.getAll();
  },

  methods: {
    getAll() {
      this.getParentJobLogg();
    },

    getParentJobLogg() {
      this.loading = true;
      this.getJobLogsByJobId(this.PartentJobId)
        .then((response) => {
          this.ParentJobLogg = response;
        })
        .catch((exception) => console.log(exception))
        .finally(() => (this.loading = false));
    },
  },

  computed: {
    PartentJobId() {
      return this.$route.params.jobId;
    },
    Subjobs() {
      return this.$store.getters["JobHub/Subjobs"];
    },

    StatusList() {
      return this.$store.getters["LookUpStore/JobStatusList"];
    },

    SubStatusList() {
      return this.$store.getters["LookUpStore/JobSubStatusList"];
    },
  },

  watch: {
    "Subjobs.length"() {
      this.getAll();
    },
  },
};
</script>

<style lang="scss" scoped>
.limitheight {
  max-height: 50vh;
  overflow-y: auto;
}
</style>